import { IconSchool16, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { LayoutJournal, OtherServices } from 'shared/components/Services';

interface IJournalSidebarContainerProps extends React.PropsWithChildren {
  isDesktop: boolean;
  children: React.ReactNode;
}

export const JournalSidebarContainer: React.FC<IJournalSidebarContainerProps> = ({ isDesktop, children }) => {
  const [isOpen, setOpen] = React.useState(false);

  const handleModalOpen = React.useCallback(() => setOpen(true), [setOpen]);

  const handleModalClose = React.useCallback(() => setOpen(false), [setOpen]);

  if (isDesktop) {
    return <LayoutJournal isDesktop={isDesktop}>{children}</LayoutJournal>;
  }

  return (
    <LayoutJournal isDesktop={isDesktop}>
      <OtherServices
        title="Ваш гид по недвижимости"
        onClick={handleModalOpen}
        icon={<IconSchool16 color="white_100" />}
        // Необходимый хардкод - потому что для мобилки ссылки открываются в модалке
        isDesktop={true}
        regularTitle={true}
      />

      <ModalWindow
        width="100%"
        title="Ваш гид по недвижимости"
        open={isOpen}
        onClose={handleModalClose}
        content={children}
      />
    </LayoutJournal>
  );
};
